export const getCspNonce = (): string =>
  document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content ?? '';
